import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class DateFormatter extends NgbDateParserFormatter {
    
    readonly DELIMITER = '/';

    parse(value: string): NgbDateStruct | null {
        if (value) {
            let date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        return date ? moment(new Date(date.year, date.month - 1, date.day)).format('MM/DD/YYYY') :'';
     //   return date ? date.month + this.DELIMITER_PAYMENT_HUB + date.day + this.DELIMITER_PAYMENT_HUB + date.year : '';
    }
}